import React, { useEffect } from "react";

const ListingAds = () => {
  return <article className="ads print">listing ads</article>;
};

export default ListingAds;
